import React from "react";

const Logo = (props: React.ComponentPropsWithoutRef<"img">) => (
  <img alt="Logo" src="/logo512.png" {...props} />
);

export default Logo;
